import { render, staticRenderFns } from "./ProcedureBranchPage.vue?vue&type=template&id=d867a228&scoped=true&"
import script from "./ProcedureBranchPage.vue?vue&type=script&lang=js&"
export * from "./ProcedureBranchPage.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureBranchPage.vue?vue&type=style&index=0&id=d867a228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d867a228",
  null
  
)

export default component.exports